module.exports = __webpack_public_path__ + "static/mount-vernon-04c3dfba2cf812d750dafa6b6bf735b8.png";